import '@fortawesome/fontawesome-free/css/all.min.css'
import '@factry/bulma/scss/bulma.scss'
import { settings } from './utils/client'
import { initializeTranslations } from '@factry/components/translate'

import App from './App.svelte'

settings.basePath = import.meta.env.VITE_BASE_PATH

// We don't have any translations, but without this function $t() doesn't work in some of the components where they are expected.
initializeTranslations()

const app = new App({
  target: document.body,
})

export default app
